
import { computed, defineComponent, reactive, toRefs, watch } from 'vue';

export default defineComponent({
    props: {
        defaultSrc: String,
        src: {
            type: String,
        },
    },
    setup(props, context) {
        const state = reactive({
            imageSrc: props.src,
        });

        const srcWithoutProtocol = computed(() => {
            return (state.imageSrc || '').replace(/^http(s)?:/, '');
        });

        // 初始化
        context.emit('init');

        const handleImageLoad = () => {
            context.emit('load');
        };

        const handleError = () => {
            if (props.defaultSrc) {
                state.imageSrc = props.defaultSrc;
            }

            context.emit('error');
        };

        watch(() => props.src, (value) => {
            state.imageSrc = value;
        });

        return {
            srcWithoutProtocol,
            handleImageLoad,
            handleError,
        };
    },
});
